import baseAPI from '@/http'

const router = 'api/municipio/grupo'

export const groupAPI = {
  create: (group) => baseAPI.post(router, group),
  update: (group) => baseAPI.put(router, group),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router + '/get-grupos'}/${id}`),
  getWithSolution: (id) => baseAPI.get(`${router + '/get-grupos-solucoes'}/${id}`)
}
